
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","stroke":"#fff","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.516 7.861l.44.887c.06.124.22.242.355.265l.797.134c.51.085.63.458.263.826l-.62.625a.55.55 0 00-.13.456l.177.774c.14.613-.182.85-.72.53l-.747-.447a.536.536 0 00-.495 0l-.747.447c-.535.32-.86.08-.72-.53l.177-.774a.55.55 0 00-.13-.456l-.62-.625c-.365-.368-.247-.74.263-.826l.797-.134a.545.545 0 00.353-.265l.44-.887c.24-.481.63-.481.867 0zM6.668 14.167v2.916M6.668 2.917v2.916","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.334 7.4c-.056-1.286-.212-2.123-.65-2.784a3.884 3.884 0 00-.924-.979c-.972-.72-2.344-.72-5.086-.72H8.328c-2.743 0-4.114 0-5.086.72-.36.267-.672.598-.924.979-.438.661-.594 1.498-.65 2.783-.01.22.18.387.387.387 1.155 0 2.091.992 2.091 2.214 0 1.223-.936 2.214-2.09 2.214-.208 0-.398.168-.388.387.056 1.285.212 2.122.65 2.783.252.381.564.712.924.979.972.72 2.343.72 5.086.72h3.346c2.742 0 4.114 0 5.086-.72.36-.267.672-.598.924-.979.438-.662.594-1.498.65-2.783V7.399z","stroke-width":"1.5","stroke-linejoin":"round"}})])
          )
        }
      }
    